import React                     from 'react';
import { Link }                  from 'react-router-dom';
import classNames                from 'classnames';
import LocaleString              from '../../shared/locale-string';
import { activityIndicatorHtml } from '../../shared/activity-indicator/activity-indicator.jsx';
import { MerchandiseIcon,
    ExperiencesIcon }            from '../../shared/icons/icons.jsx';
import OnTheSpot                 from '../../shared/on-the-spot';

import './home.scss';

export default class Home extends React.Component {
    UNSAFE_componentWillMount() {//eslint-disable-line
        this.props.dismissAllErrors();
    }

    handleShopClick = type => {
        const newTab = window.open( '', '_blank' );
        newTab.document.body.innerHTML = activityIndicatorHtml;

        this.props.fetchCatalogUrl( type )
            .then( catalogUrl => {
                newTab.location.href = catalogUrl;
                newTab.focus();
            } )
            .catch( error => {
                newTab.close();
                throw error;
            } );
    };

    render() {
        const {
            user,
            mediaLabel,
            catalogUrlErrors
        } = this.props;

        const locale = user.locale.code;
        const balance = new Intl.NumberFormat( locale ).format( user.accountBalance );

        let shopHeader = 'home.header.shopMerchLabel';
        let experiencesHeader = 'home.header.shopExperiencesLabel';
        const catalogDownMessage = <LocaleString code="home.content.catalogDownMessage" />;

        if ( catalogUrlErrors.length || user.rewardsOfferingUnavailable ) {
            shopHeader = 'home.header.merchDownLabel';
            experiencesHeader = 'home.header.travelDownLabel';
        }

        const replaceOpts = {
            firstName: user.firstName,
            mediaLabel
        };

        const allSpentMessage = (
            <span>
                <LocaleString code="home.content.welcomeMessageAllSpent" replaceOptions={ replaceOpts } />
                <Link to="/activity-history" className="spent-all-msg">
                    <LocaleString code="home.content.allSpentMessage" replaceOptions={ replaceOpts } />
                </Link>
            </span>
        );

        const hasPointsMessage = (
            <span>
                <LocaleString code="home.content.welcomeMessageLabel" replaceOptions={ replaceOpts } />
                <Link to="/activity-history">
                    <p className="points branded">
                        { balance }
                        { ' ' }
                        <span className="media-label">{ mediaLabel }</span>
                    </p>
                </Link>
            </span>
        );

        return (

            <main className="home" role="main">
                <div>
                    <header className="sr-only" role="banner"><h1>Home</h1></header>
                    <div className="points-section">
                        {
                            user.accountBalanceUnavailable
                            ? <LocaleString code="home.content.welcomeMessageUnavailable" replaceOptions={ replaceOpts } />
                            : user.accountBalance === null
                            ? <LocaleString code="home.content.welcomeMessageNeverEarned" replaceOptions={ replaceOpts } />
                            : user.accountBalance <= 0
                            ? allSpentMessage
                            : hasPointsMessage
                        }

                    </div>

                    <div className="container">
                        {
                            !!( user.rewardsOffering && user.rewardsOffering.merchandise ) &&
                                <Shop
                                    title={ <LocaleString code={ shopHeader } /> }
                                    btnLabel={ <LocaleString code="home.button.viewCatalogLabel" /> }
                                    btnDisabled={ !!user.adminAsUser }
                                    type={ 'merchandise' }
                                    handleShopClick={ this.handleShopClick }
                                    error={ {
                                        hasError: catalogUrlErrors.length > 0,
                                        message: catalogDownMessage
                                    } } />
                        }

                        {
                            !!( user.rewardsOffering && user.rewardsOffering.experiences ) &&
                                <Shop
                                    title={ <LocaleString code={ experiencesHeader } /> }
                                    btnLabel={ <LocaleString code="home.button.viewExperiencesLabel" /> }
                                    btnDisabled={ !!user.adminAsUser }
                                    type={ 'experiences' }
                                    handleShopClick={ this.handleShopClick }
                                    error={ {
                                        hasError: catalogUrlErrors.length > 0,
                                        message: catalogDownMessage
                                    } } />
                        }

                        {
                            // Show a single tile if we are not able to determine which
                            // reward offerings the client has.
                            user.rewardsOfferingUnavailable &&
                                <Shop
                                    title={ <LocaleString code={ shopHeader } /> }
                                    type={ 'merchandise' }
                                    error={ {
                                        hasError: true,
                                        message: catalogDownMessage
                                    } } />
                        }
                    </div>

                    {
                        user && user.participantFeatures && user.participantFeatures.ots &&
                        <OnTheSpot disable={ !!user.adminAsUser } mediaLabel={ mediaLabel } />
                    }
                </div>
            </main>
        );
    }
}

export const Shop = props => {
    const {
        type,
        title,
        error,
        btnDisabled,
        handleShopClick,
        btnLabel
    } = props;

    const btnClasses = classNames( {
        'btn': true,
        'disabled': btnDisabled
    } );

    const icon = type === 'merchandise'
                 ? <div className="icon"><MerchandiseIcon /></div>
                 : <div className="icon"><ExperiencesIcon /></div>;

    const handleClick = event => {
        event.preventDefault();
        return btnDisabled ? false : handleShopClick( type );
    };

    const btnContent = error.hasError
                       ? <p>{ error.message }</p>
                       : <a href="#" className={ btnClasses } onClick={ handleClick }>{ icon }{ btnLabel }</a>;

    return (
        <div className={ `shop-tile ${ type }` }>
            <div className="shop-tile-shader"></div>
            <div className="shop-tile-content">
                <h3>{ title }</h3>
                { btnContent }
            </div>
        </div>
    );
};
